import React from 'react'
import { GetProjectResultType } from '../../../../services/web/types/responseWebServiceTypes'
import { UseResearchDetailType } from './researchDetailType'
import _ from 'lodash'
const useResearchDetail = (props: UseResearchDetailType) => {
    const { dataSource } = props
    const [initialData, setInitialData] = React.useState<GetProjectResultType>()

    React.useEffect(() => {
        if (dataSource) {
            setInitialData(dataSource)
        }
        // }, [JSON.stringify(dataSource)])
    }, [dataSource?.projectID ?? null, dataSource?.submittedID ?? null])

    return { initialData }
}

export default useResearchDetail
